import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// import './compiled/ViewSuccess.css';

export default class ViewSuccess extends Component {
  // Constructor
  constructor(props) {
    super();

    this.state = {};
  }

  // Life-cycle
  componentDidMount() {}

  // Handlers

  // Render
  render() {
    let success_emoji = (
      <span role="img" aria-label="celebrate">
        🎉
      </span>
    );

    return (
      <div className="ViewSuccess section">
        <div className="container">
          <h2>Success {success_emoji}</h2>
          <p>Thank you for posting your feedback.</p>
          <p>
            <Link to="/">Submit another issue.</Link>
          </p>
        </div>
      </div>
    );
  }
}
